import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { getSettingFactory } from "@faire/web/common/SerializedSetting";
/**
 * Functions that provides synchronous access to settings that are serialized to the page, while handling frontend
 * overrides and default values if the setting is missing.
 */
var _getSettingFactory = getSettingFactory(
  // Prevent direct lookup of settings values.
  function () {
    return getGlobalProperty("settingsValues") || {};
  }),
  getSettingValueWithoutAssignment = _getSettingFactory.getSettingValueWithoutAssignment,
  getSettingValueAndAssign = _getSettingFactory.getSettingValueAndAssign,
  assignSetting = _getSettingFactory.assignSetting;
export { getSettingValueWithoutAssignment, getSettingValueAndAssign, assignSetting };